<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', {'client':contact.client_id})">Udziałowcy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('contacts.edit', {'client':contact.client_id, 'contact':contact.id})">{{ contact.first_name }} {{ contact.last_name }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Historia
      <div class="inline" v-if="!has_year">
        <inertia-link class="btn-shtax ml-auto absolute right-0 top-0 disabled:opacity-50" :href="route('sharer-history.create', {'contact':contact.id})">
          <span>Nowy wpis</span>
          <span class="hidden md:inline">do historii</span>
        </inertia-link>
      </div>
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap text-xs">
        <tr class="text-left font-bold">
          <th class="px-3 pt-3 pb-4">Rok</th>
          <th class="px-3 pt-3 pb-4">Sposób rozliczania<br>podatku</th>
          <th class="px-3 pt-3 pb-4">Brak kwoty<br>wolnej</th>
          <th class="px-3 pt-3 pb-4">PIT<br>kwartalny</th>
          <th class="px-3 pt-3 pb-4">Rozliczenie<br>wspólne</th>
          <th class="px-3 pt-3 pb-2">Liniowy</th>
          <th class="px-3 pt-3 pb-2">Kwota upr</th>
          <th class="px-3 pt-3 pb-2">Małżonek - ulgi</th>
        </tr>
        <tr v-for="history in histories.data" :key="history.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :class="{'bg-red-50': year != history.rok}">
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.rok }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center" tabindex="-1">
              {{ history.sposob_rozliczania_podatku }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.brak_wolnej }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.pit_kwartalny }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.rozliczenieWspolne }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center whitespace-normal" tabindex="-1">
              {{ history.liniowy }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.kwota_upr }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-3 py-2 flex items-center focus:text-shtax-500">
              {{ history.ulgi }}
            </span>
          </td>
        </tr>
        <tr v-if="histories.length === 0">
          <td class="border-t px-3 py-2" colspan="8">Historia udziałowca jest pusta.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-3" :links="histories.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: { title: 'Historia udziałowca' },
  components: {
    Icon,
    Pagination,
  },
  layout: Layout,
  props: {
    contact: Object,
    histories: Object
  },
  data() {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {
    has_year() {
      return this.histories.data.filter(history => history.rok == this.year).length > 0
    }
  }
}
</script>
